import { render, staticRenderFns } from "./BodySizeIndex.vue?vue&type=template&id=8784a432&scoped=true&"
import script from "./BodySizeIndex.vue?vue&type=script&lang=js&"
export * from "./BodySizeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8784a432",
  null
  
)

export default component.exports